export default {"id":"d3307e3d","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}